const quote = {
  namespaced: true,
  state: () => ({
    additionalClauseInsured: null,
  }),

  mutations: {
    SET_ADDITIONAL_CLAUSE_INSURED: (state, data) => {
      state.additionalClauseInsured = data;
    },
  },
};

export default quote;



// WEBPACK FOOTER //
// ./src/store/modules/quote.js